export {categoriestrail} from "./categoriestrail";



// WEBPACK FOOTER //
// ./src/reducers/navigation.js